import {
  IconInfrastructureKid16,
  IconInfrastructureHospital16,
  IconMapMetroMsk16,
  IconInfrastructureStore16,
  IconInfrastructureSchool16,
} from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import { EType } from '../types/map';

export const INFRASTRUCTURE_MAP_ICON_MAP = new Map<string, React.FunctionComponent>([
  [EType.Clinic, IconInfrastructureHospital16],
  [EType.Grocery, IconInfrastructureStore16],
  [EType.Metro, IconMapMetroMsk16],
  [EType.Nursery, IconInfrastructureKid16],
  [EType.School, IconInfrastructureSchool16],
]);
